import { render, staticRenderFns } from "./UserReviews.vue?vue&type=template&id=3fb1b614&scoped=true"
import script from "./UserReviews.vue?vue&type=script&lang=js"
export * from "./UserReviews.vue?vue&type=script&lang=js"
import style0 from "./UserReviews.vue?vue&type=style&index=0&id=3fb1b614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb1b614",
  null
  
)

export default component.exports